module.exports = __webpack_public_path__ + "static/media/layout1-vid.364930b7.svg";